import { PRInputEntity } from '@finance-lab/utils/types'
import ApiBase from './Api'

const PR_INPUTS_API_PATHS = {
    PR_INPUTS: '/admin/prinputs',
}
class PRInputsApi extends ApiBase {
    async findAll() {
        const response = await this._getRequest(PR_INPUTS_API_PATHS.PR_INPUTS)

        return response as PRInputEntity[]
    }

    async archive(pr: PRInputEntity): Promise<PRInputEntity> {
        const response = (await this._patchRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/archive',
            {},
            { prId: pr.id },
        )) as PRInputEntity

        return response
    }

    async unArchive(pr: PRInputEntity): Promise<PRInputEntity> {
        const response = (await this._patchRequest(
            PR_INPUTS_API_PATHS.PR_INPUTS + '/unarchive',
            { archived: false },
            { prId: pr.id },
        )) as PRInputEntity

        return response
    }
}

export default PRInputsApi
